import { Typography } from '@curology/ui-components-web/react';
import { CardImage } from '@curology/ui-components-web/react/Card/CardImage';
import { CardTitle } from '@curology/ui-components-web/react/Card/CardTitle';
import { MediaCard } from '@curology/ui-components-web/react/Card/MediaCard';
import { MediaCardContent } from '@curology/ui-components-web/react/Card/MediaCard/MediaCardContent';
import { BagIcon } from '@curology/ui-components-web/react/Icon/icons/BagIcon';
import { HeartIcon } from '@curology/ui-components-web/react/Icon/icons/HeartIcon';
import { Label } from '@curology/ui-components-web/react/Label';
import { Tooltip } from '@curology/ui-components-web/react/Tooltip';
import { TooltipContent } from '@curology/ui-components-web/react/Tooltip/TooltipContent';
import { TooltipTrigger } from '@curology/ui-components-web/react/Tooltip/TooltipTrigger';
import React from 'react';

const ProductComparison = () => {
  return (
    <div className="cur-flex cur-my-4">
      <div className="cur-basis-2/4">
        <div className="cur-h-full cur-pr-2">
          <MediaCard className="cur-h-full">
            <MediaCardContent
              image={
                <CardImage
                  alt="The cleanser product comparison image"
                  aspectRatio="4:5"
                  src="https://images.ctfassets.net/mdcr7mahi0vp/4EyRZMWsihzNySotBIGSRp/a536b77f6cad1ed51c45e73856279818/cleanser.png"
                />
              }
              label={
                <Label labelType="disabled">
                  <BagIcon className="cur-mr-1" size="xs" />
                  In your box
                </Label>
              }
              title="The cleanser"
            >
              <Typography size="meta" className="cur-mb-2">
                Gentle, lightly foaming face wash
              </Typography>
            </MediaCardContent>
          </MediaCard>
        </div>
      </div>
      <div className="cur-basis-2/4">
        <div className="cur-h-full cur-pl-2">
          <MediaCard className="cur-h-full">
            <MediaCardContent
              image={
                <CardImage
                  alt="Deep Cleanse Rx product comparison image"
                  aspectRatio="4:5"
                  label={<Label>Prescription</Label>}
                  src="https://images.ctfassets.net/mdcr7mahi0vp/6GVKAVqqVwuYN6rkAvG0v5/19ac6241e02244011b2b6d37b91a80fc/deep_cleanse.png"
                />
              }
              label={
                <Label labelType="subtle">
                  <HeartIcon className="cur-mr-1" size="xs" />
                  Designed for you
                </Label>
              }
              // @ts-expect-error TS is throwing an error that seems unnecessary. Could be related to the TS versions being out of sync.
              title={
                <CardTitle>
                  Deep Cleanse<sup>Rx</sup>
                </CardTitle>
              }
            >
              <Typography size="meta" className="cur-mb-2">
                Personalized with 2-3{' '}
                <Tooltip as="span">
                  <TooltipTrigger className="cur-underline">
                    active ingredients
                  </TooltipTrigger>
                  <TooltipContent className="cur-text-[#ffffff]">
                    Your provider will review your answers and photos, and then
                    prescribe a combination of sulfacetamide, zinc pyrithione,
                    and/or salicylic acid for your skin’s unique needs.
                  </TooltipContent>
                </Tooltip>
              </Typography>
            </MediaCardContent>
          </MediaCard>
        </div>
      </div>
    </div>
  );
};

export default ProductComparison;
